module.exports = __webpack_public_path__ + "img/personal-id-card-of-a-man_azul.29520237.svg";